import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateCard, updateInvoice, annulStoreErrors, deleteCard, deleteInvoice } from '../../reducers/payment/duck';
import { getProfileStatus, getProfile } from '../../reducers/user/duck';
import AddPayment from './AddPayment';

const mapStateToProps = ({
  paymentStore: {
    updateCardStatus,
    updateInvoiceStatus,
    updateCardError,
    updateInvoiceError,
    deleteCardStatus,
    deleteCardError,
    deleteInvoiceStatus,
    deleteInvoiceError,
  },
  userStore: {
    profileStepStatus,
    cardMethod,
    status: userStatus,
    invoiceMethod,
  },
}) => ({
  updateCardStatus,
  updateInvoiceStatus,
  updateCardError,
  updateInvoiceError,
  profileStepStatus,
  cardMethod,
  userStatus,
  invoiceMethod,
  deleteCardStatus,
  deleteCardError,
  deleteInvoiceStatus,
  deleteInvoiceError,
});
const mapDispatchToProps = {
  updateCard,
  deleteCard,
  updateInvoice,
  annulStoreErrors,
  getProfileStatus,
  deleteInvoice,
  getProfile,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddPayment));



// WEBPACK FOOTER //
// ./src/containers/AddPayment/index.js